<template>
  <div data-v-03b1ba29="" class="payment-method dekbox">
    <div class="demain">
      <div data-v-03b1ba29="" class="topup-title">
        <span data-v-03b1ba29="">{{ $t('_cbsq._bz') }}</span>
      </div>
      <div data-v-03b1ba29="" class="vip-wrapper">
        <div data-v-03b1ba29="" :class="['vip-item', currencyIndex == i ? 'active' : '']" v-for="(vo, i) in currencyList" :key="i" @click="onCurrencyChange(i)">
          <div data-v-03b1ba29="" class="vip-item-left">
            <div data-v-03b1ba29="" class="vip-item-top">
              <span data-v-03b1ba29="" class="vip-item-title">{{ vo.text }}</span>
              <div data-v-03b1ba29="" class="vip-item-price-wrapper">
                <img :src="require('../../static/img_icon/' + vo.text.toLowerCase() + '.png')" style="width: 40px" />
              </div>
            </div>
          </div>
          <!-- <div data-v-03b1ba29="" class="vip-item-mark vip-item-mark-1"
                                    style="background: rgb(251, 56, 103);">
                                    <span data-v-03b1ba29="">Super Value</span>
                                </div>
                                <div data-v-03b1ba29="" class="vip-item-bg oss-image-wrapper vip-item-bg"
                                    style="background: url(&quot;https://file-cdn..cc/image/43/60e5fb25b9272e6509a18236e68575.png?image_process=resize,w_110/quality,Q_75/format,webp&quot;) center top / 100% no-repeat;">
                                </div> -->
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_cbsq._wl') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div data-v-03b1ba29="" :class="['payment-item', protocolIndex == i ? 'active' : '']" v-for="(vo, i) in protocolList" :key="i" @click="onProtocolClick(i)">
            <div>{{ vo.network }}</div>
          </div>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <div style="display: flex; align-items: center; margin-bottom: 20px">
          <div data-v-03b1ba29="" class="asdrt">{{ $t('_cbsq._erwm') }}:</div>
          <div style="">{{ current.name }}-{{ current.network }}</div>
        </div>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div data-v-03b1ba29="" class="">
            <div class="qrcodebox qrboxx">
              <img :src="current.qr_code" style="width: 300px; height: 300px" />
              <div class="qrdde" style="background-color: #0b0d0f;">{{ current.address }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div data-v-03b1ba29="" class="tips-wrapper">
        <div data-v-982acdfa="" data-v-03b1ba29="" class="tips">
          <p data-v-982acdfa="">Tips:</p>
          <p data-v-982acdfa="">1. ReelShortPro has free and paid content for everyone. You decide which content to unlock</p>
          <p data-v-982acdfa="">2. Coins will be used to unlock paid content</p>
          <p data-v-982acdfa="">3. Refill coins and bonus are equal value. Recharge does not support refund</p>
          <p data-v-982acdfa="">4. If you have other problems, please contact us</p>
        </div>
      </div> -->
    </div>
  </div>
  <div data-v-03b1ba29="" class="payment-footer btnc">
    <button data-v-03b1ba29="" class="payment-btn" @click="onCopy(current.address)">
      <span data-v-03b1ba29="">{{ $t('_cbsq._fzdz') }}</span>
    </button>
    <button data-v-03b1ba29="" class="payment-btn btnf" @click="onBack('wallet')">
      <span data-v-03b1ba29="">{{ $t('_sp._fanh') }}</span>
    </button>
  </div>
  <!-- <div data-v-4490912c="" data-v-03b1ba29="" class="loading" style="display: none;"><img
                            data-v-4490912c="" src="https://www..cc/_nuxt/loading.Czr7mSn8.png"></div> -->
</template>

<script>
export default {
  name: 'depositVue',
  data() {
    return {
      currencyList: [],
      currencyIndex: 0,

      protocolList: [],
      protocolIndex: 0,
      current: {}
    }
  },
  created() {
    this.getCurrencyList()
  },
  methods: {
    onBack(name) {
      this.$router.push({ name: name })
    },
    getCurrencyList() {
      let that = this
      this.$api.chain.getCurrencyList().then((res) => {
        that.currencyList = res.data
        //默认第一个
        that.onCurrencyChange(that.currencyIndex)
      })
    },
    onCurrencyChange(i) {
      this.currencyIndex = i
      this.protocolList = this.currencyList[i].protocol
      this.onProtocolClick(0)
    },
    onProtocolClick(i) {
      this.protocolIndex = i
      this.current = this.protocolList[i]
    },
    onCopy(token) {
      console.log(token)
      // copyData想要复制的内容
      this.$copyText(token)
        .then(() => {
          this.$message.success('copy success! ' + token)
        })
        .catch(() => {
          this.$message.error('copy fail')
        })
    }
  }
}
</script>
<style scoped>
@import url('../../static/css_deposit/index.B4UqQ7MX.css');
</style>
<style>
.dekbox {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.demain {
  width: 1200px;
}

.record-a {
  padding-top: 36px;
}

.asdrt {
  color: #fff;
  font-family: Ubuntu-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
}
</style>
